import type * as Types from '../../types';

import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import document from './rootPlaceMenuItemWithReviewsQuery.gql';
import type * as ApolloReactCommon from '~/lazy_apollo/client';
import * as ApolloReactHooks from '~/lazy_apollo/client';
const defaultOptions = {} as const;
export type RootPlaceMenuItemWithReviewsQuery_rootPlace_RootPlace_menuItem_MenuItem_paginatedReviews_ReviewPaginationHandler_records_Review = {
  __typename: 'Review',
  id: number,
  content?: string | null,
  createdAt?: string | null,
  reviewUpvotesCount?: number | null,
  userAvatarUrl: string,
  userDisplayName: string
};

export type RootPlaceMenuItemWithReviewsQuery_rootPlace_RootPlace_menuItem_MenuItem_paginatedReviews_ReviewPaginationHandler = {
  __typename: 'ReviewPaginationHandler',
  count: number,
  hasMore: boolean,
  offset: number,
  records: Array<RootPlaceMenuItemWithReviewsQuery_rootPlace_RootPlace_menuItem_MenuItem_paginatedReviews_ReviewPaginationHandler_records_Review>
};

export type RootPlaceMenuItemWithReviewsQuery_rootPlace_RootPlace_menuItem_MenuItem = {
  __typename: 'MenuItem',
  id: number,
  paginatedReviews: RootPlaceMenuItemWithReviewsQuery_rootPlace_RootPlace_menuItem_MenuItem_paginatedReviews_ReviewPaginationHandler
};

export type RootPlaceMenuItemWithReviewsQuery_rootPlace_RootPlace = {
  __typename: 'RootPlace',
  id: number,
  menuItem?: RootPlaceMenuItemWithReviewsQuery_rootPlace_RootPlace_menuItem_MenuItem | null
};

export type RootPlaceMenuItemWithReviewsQuery_Query = {
  __typename?: 'Query',
  rootPlace: RootPlaceMenuItemWithReviewsQuery_rootPlace_RootPlace
};


export type RootPlaceMenuItemWithReviewsQueryVariables = Types.Exact<{
  rootPlaceSlug: Types.Scalars['String']['input'];
  menuItemId: Types.Scalars['Int']['input'];
  approved?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  pagination?: Types.InputMaybe<Types.PaginationInput>;
}>;


export type RootPlaceMenuItemWithReviewsQuery = RootPlaceMenuItemWithReviewsQuery_Query;


export const RootPlaceMenuItemWithReviewsDocument = /*#__PURE__*/ document as unknown as DocumentNode<RootPlaceMenuItemWithReviewsQuery, RootPlaceMenuItemWithReviewsQueryVariables>;


/**
 * __useRootPlaceMenuItemWithReviewsQuery__
 *
 * To run a query within a React component, call `useRootPlaceMenuItemWithReviewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRootPlaceMenuItemWithReviewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRootPlaceMenuItemWithReviewsQuery({
 *   variables: {
 *      rootPlaceSlug: // value for 'rootPlaceSlug'
 *      menuItemId: // value for 'menuItemId'
 *      approved: // value for 'approved'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useRootPlaceMenuItemWithReviewsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<RootPlaceMenuItemWithReviewsQuery, RootPlaceMenuItemWithReviewsQueryVariables> & ({ variables: RootPlaceMenuItemWithReviewsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RootPlaceMenuItemWithReviewsQuery, RootPlaceMenuItemWithReviewsQueryVariables>(RootPlaceMenuItemWithReviewsDocument, options);
      }
export function useRootPlaceMenuItemWithReviewsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RootPlaceMenuItemWithReviewsQuery, RootPlaceMenuItemWithReviewsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RootPlaceMenuItemWithReviewsQuery, RootPlaceMenuItemWithReviewsQueryVariables>(RootPlaceMenuItemWithReviewsDocument, options);
        }
export function useRootPlaceMenuItemWithReviewsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RootPlaceMenuItemWithReviewsQuery, RootPlaceMenuItemWithReviewsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<RootPlaceMenuItemWithReviewsQuery, RootPlaceMenuItemWithReviewsQueryVariables>(RootPlaceMenuItemWithReviewsDocument, options);
        }
export type RootPlaceMenuItemWithReviewsQueryHookResult = ReturnType<typeof useRootPlaceMenuItemWithReviewsQuery>;
export type RootPlaceMenuItemWithReviewsLazyQueryHookResult = ReturnType<typeof useRootPlaceMenuItemWithReviewsLazyQuery>;
export type RootPlaceMenuItemWithReviewsSuspenseQueryHookResult = ReturnType<typeof useRootPlaceMenuItemWithReviewsSuspenseQuery>;
export type RootPlaceMenuItemWithReviewsQueryResult = ApolloReactCommon.QueryResult<RootPlaceMenuItemWithReviewsQuery, RootPlaceMenuItemWithReviewsQueryVariables>;